import PropTypes from 'prop-types';
import React from 'react';

function UserContact(props) {
  const { fill } = props;
  return (
    <svg
      height="24"
      style={{ fill: 'none' }}
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.5 21.375H18.875C19.5654 21.375 20.125 20.8154 20.125 20.125V3.875C20.125 3.18464 19.5654 2.625 18.875 2.625H7.5M7.5 21.375H5.125C4.43464 21.375 3.875 20.8154 3.875 20.125V3.875C3.875 3.18464 4.43464 2.625 5.125 2.625H7.5M7.5 21.375V2.625"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.25"
      />
      <path
        d="M11.7979 9.58694C11.7979 8.47946 12.6956 7.58167 13.8031 7.58167C14.9106 7.58167 15.8084 8.47946 15.8084 9.58694C15.8084 10.6944 14.9106 11.5922 13.8031 11.5922C12.6956 11.5922 11.7979 10.6944 11.7979 9.58694Z"
        stroke={fill}
        strokeWidth="1.25"
      />
      <path
        d="M13.8124 13.1886C15.0567 13.1886 16.0616 13.7428 16.8272 14.8599L16.9055 14.9775C17.1859 15.41 17.0625 15.9879 16.63 16.2682C16.5004 16.3522 16.3524 16.4025 16.1993 16.4151L16.1224 16.4183H11.5023C10.9869 16.4183 10.5691 16.0005 10.5691 15.4851C10.5691 15.3049 10.6212 15.1286 10.7192 14.9775C11.4941 13.782 12.5251 13.1886 13.8124 13.1886Z"
        stroke={fill}
        strokeWidth="1.25"
      />
    </svg>
  );
}

UserContact.propTypes = {
  fill: PropTypes.string.isRequired
};

export default UserContact;
